import { getNewSaCurrency } from '@/common/utils'
import { VpPriceCurrency } from '../types'

export const getPrice = (i18nClinet: any, price?: VpPriceCurrency) => getNewSaCurrency(i18nClinet, `${price?.displayText || ''}`)
